import React, { useState } from "react";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
} from "reactstrap";
import FinancialTransactionForm from "./FinancialTransactionForm";
import MonthlyRecord from "./MonthlyLedger";
import BankTransactionForm from "./BankTransaction";

const MonthlyAccounts = () => {
    const [activeTab, setActiveTab] = useState("addTransaction");

    return (
        <Container>
            <Row>
                <Col>
                    <Card>
                        <CardHeader>
                            <h3 className="mb-0">Monthly Accounts</h3>
                            <div className="d-flex justify-content-around">
                                <Button
                                    color={activeTab === "addTransaction" ? "primary" : "secondary"}
                                    onClick={() => setActiveTab("addTransaction")}
                                >
                                    Cash Transaction
                                </Button>
                                <Button
                                    color={activeTab === "bankTransaction" ? "primary" : "secondary"}
                                    onClick={() => setActiveTab("bankTransaction")}
                                >
                                    Bank Transaction
                                </Button>
                                <Button
                                    color={activeTab === "monthlyLedger" ? "primary" : "secondary"}
                                    onClick={() => setActiveTab("monthlyLedger")}
                                >
                                    Monthly Ledger
                                </Button>

                            </div>
                        </CardHeader>
                        <CardBody>
                            {activeTab === "addTransaction" && <FinancialTransactionForm />}
                            {activeTab === "monthlyLedger" && <MonthlyRecord />}
                            {activeTab === "bankTransaction" && <BankTransactionForm />}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default MonthlyAccounts;
